<div class="card-title">{{"preview_booking"|translate}}</div>
<div class="cart-item" *ngFor="let item of order.services">
    <span class="highlight">{{ item.amount }}x</span> {{ translateHelper.localize(item.name)}}
    <app-booking-line-summary [line]="item"></app-booking-line-summary>
    <div *ngIf="item.options?.length > 0 || item.variant" class="order-list__options">
        <app-options-details [options]="item.options"  [variant]="item.variant"></app-options-details>
    </div>
    <div class="item-price">{{ item.total|currencyFormat }}</div>
</div>
<div class="cart-item" *ngFor="let item of order.extraServices">
    <span class="highlight">{{ item.amount }}x</span> {{ translateHelper.localize(item.name)}}
    <div *ngIf="item.options?.length > 0 || item.variant" class="order-list__options">
        <app-options-details [options]="item.options"  [variant]="item.variant"></app-options-details>
    </div>
    <div class="item-price">{{ item.total|currencyFormat }}</div>
</div>

<ng-container *ngIf="order.additionalLines?.length > 0">
<div class="card-divider"></div>
<div class="items-total">
    <table>
        <tbody>
            <tr>
                <th class="title">{{"subtotal"|translate}}</th>
                <th class="price">{{ order?.subtotal|currencyFormat }}</th>
            </tr>
            <tr *ngFor="let line of order.additionalLines">
                <th class="title">{{ line.label }}</th>
                <th class="price">{{ line.total|currencyFormat }}</th>
            </tr>
        </tbody>
    </table>
</div>
</ng-container>

<div class="card-divider"></div>
<div class="items-total">
    <table>
        <tbody>
            <tr>
                <th class="title">{{"subtotal"|translate}}</th>
                <th class="price">{{ order?.subtotal|currencyFormat }}</th>
            </tr>
            <tr *ngIf="order.discountTotal">
                <th class="title">{{"discount"|translate}}</th>
                <th class="price">{{ order?.discountTotal|currencyFormat }}</th>
            </tr>
            <tr *ngIf="order.taxTotal">
                <th class="title">{{"tax"|translate}}</th>
                <th class="price">{{ order?.taxTotal|currencyFormat }}</th>
            </tr>
            <tr>
                <th class="title">{{"total"|translate}}</th>
                <th class="price">{{ order?.total|currencyFormat }}</th>
            </tr>
        </tbody>
    </table>
</div>

<ng-container *ngIf="order.expectedTimeRange">
<div class="card-divider"></div>
<div class="order-notes">
    <small class="d-block font-weight-bold">{{"expected_time"|translate}}</small>
    <small class="d-block font-weight-bold">
        <span class="label">{{"from"|translate}}:</span>
        <span class="highlight">{{order.expectedTimeRange.start|date: "medium"}}</span>
    </small>
    <small class="d-block font-weight-bold">
        <span class="label">{{"to"|translate}}:</span>
        <span class="highlight">{{order.expectedTimeRange.end|date: "medium"}}</span>
    </small>
</div>
</ng-container>
